import DocumentFolderLine from './document-folder-line.component.js'

export * from './document-folder-line.component.js'
export default DocumentFolderLine

DocumentFolderLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-folder-line': DocumentFolderLine
  }
}
